import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { agentsService } from '../../services';
import W9Form from './W9Form';
import W8BENForm from './W8BENForm';
import './TaxForms.css';

const TaxFormSelection = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [agentCountry, setAgentCountry] = useState(null);
  const [hasTaxForm, setHasTaxForm] = useState(false);

  useEffect(() => {
    checkTaxFormStatus();
  }, []);

  const checkTaxFormStatus = async () => {
    try {
      // Get agent profile to determine country and tax form status
      const response = await agentsService.getProfile();
      const profile = { data: response?.data || response || {} };
      
      // Check if agent has already submitted a tax form
      if (profile.data.has_tax_form) {
        // Agent has already submitted tax form, redirect to dashboard
        navigate('/agent/dashboard');
        return;
      }
      
      // Set the agent's country
      setAgentCountry(profile.data.country || 'US');
      setHasTaxForm(false);
    } catch (error) {
      console.error('Error checking tax form status:', error);
      // Default to US form if there's an error
      setAgentCountry('US');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="tax-form-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading tax form requirements...</p>
        </div>
      </div>
    );
  }

    const handleFormComplete = () => {
    // Navigate to dashboard after successful form submission
    navigate('/agent/dashboard');
  };

  // Show W-9 for US agents, W-8BEN for all others
  return agentCountry === 'US' ? <W9Form onComplete={handleFormComplete} /> : <W8BENForm onComplete={handleFormComplete} />;
};

export default TaxFormSelection;